import styled from 'styled-components'
import {deviceMax} from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import CardNews from "../CardNews/CardNews";

export const StyledListWithPagination = styled.div`
  flex-direction: column;
  align-items: center;
  display: flex;
  width: 100%;
  padding: 0;
  margin-top: ${pxToRem(20)}
`

export const StyledListContainer = styled.div`
  justify-content: center;
  flex-wrap: wrap;
  display: flex;
  max-width: ${pxToRem(1220)};
  padding: 0;
`

export const StyledCardNews = styled(CardNews)`
  @media ${deviceMax.tablet} {
    max-height: none;
  }
`
